import { Typography, CircularProgress, Grid, Chip } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Wrapper } from "components/wrapper";
import { DetailCard, DetailField, DetailSectionTitle } from "components/detailPage";
import { DocumentList } from "components/documentList";
import { ExportButtons } from "components/exportButtons";
import { useDocumentoSetorialDetailsState } from "./context/documento-setorial-details-context";
import { useDocumentoSetorialDetailsController } from "./context/documento-setorial-details-controller";
import { formatPeriodo } from "pages/documentosSetoriais/documentosSetoriaisTable.component";

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString('pt-BR') : '-';

export function DocumentoSetorialDetailsPage() {
  const { documentoSetorialDetails, loading, error } = useDocumentoSetorialDetailsState();
  const { loadDocumentoSetorialDetails, clearDocumentoSetorialDetails, exportDocumentoSetorialDetail } = useDocumentoSetorialDetailsController();
  let { id } = useParams<{ id: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (id) {
      loadDocumentoSetorialDetails(parseInt(id));
    }

    return () => {
      clearDocumentoSetorialDetails();
    };
  }, [id, loadDocumentoSetorialDetails, clearDocumentoSetorialDetails]);

  if (loading) {
    return (
      <Wrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress />
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <Typography color="error" variant="h6">{error}</Typography>
      </Wrapper>
    );
  }

  if (!documentoSetorialDetails) {
    return (
      <Wrapper>
        <Typography variant="h6">Registro não encontrado.</Typography>
      </Wrapper>
    );
  }

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Saúde, Educação e Assistência Social", href: "/documentos-setoriais" },
          { label: documentoSetorialDetails.tipoDocumentoSetorialName },
        ]}
      />
      <PageTitle>{documentoSetorialDetails.tipoDocumentoSetorialName}</PageTitle>
      <Wrapper>
        <ExportButtons onExport={(format) => exportDocumentoSetorialDetail(Number(id), format)} />
        <DetailCard>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Chip label={documentoSetorialDetails.areaName} color="primary" style={{ marginRight: 8 }} />
              <Chip
                label={documentoSetorialDetails.indStatus === 2 ? 'Finalizado' : 'Em Execução'}
                color={documentoSetorialDetails.indStatus === 2 ? 'primary' : 'default'}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <DetailField label="Período" value={formatPeriodo(documentoSetorialDetails.indPeriodicidade, documentoSetorialDetails.ano, documentoSetorialDetails.periodo)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DetailField label="Data de Publicação" value={formatDate(documentoSetorialDetails.dtaPublicacao)} />
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Descrição</DetailSectionTitle>
            </Grid>

            <Grid item xs={12}>
              <DetailField label="Descrição" value={documentoSetorialDetails.textoDescricao} />
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Documentos</DetailSectionTitle>
              <DocumentList documents={documentoSetorialDetails.anexos} />
            </Grid>
          </Grid>
        </DetailCard>
      </Wrapper>
    </>
  );
}
